import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyController/CtrlDashboardReqs/CtrlDashboardReqs';

function* getWebmasterDashboard(action) {
    try {
        const result = yield call(req.getWebmasterDashboardReq, action);
        if (result?.success === true) {
            yield put({ type: types.GET_WEBMASTER_DASHBOARD_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_WEBMASTER_DASHBOARD_FAILURE, message: result?.message });
        }
    } catch (e) {
        yield put({ type: types.GET_WEBMASTER_DASHBOARD_FAILURE, message: e?.message });
    }
}

function* getCtrlAllComplaints(action) {
    try {
        const result = yield call(req.getCtrlAllComplaintsReq, action);
        if (result?.success === true) {
            yield put({
                type: types.GET_CTRL_ALL_COMPLAINTS_SUCCESS,
                payload: result.data,
                pagination: result?.meta?.pagination,
            });
        } else {
            // The 400 body has no `success` field — `message` is set either way.
            yield put({ type: types.GET_CTRL_ALL_COMPLAINTS_FAILURE, message: result?.message });
        }
    } catch (e) {
        yield put({ type: types.GET_CTRL_ALL_COMPLAINTS_FAILURE, message: e?.message });
    }
}

export default function* ctrlDashboardSaga() {
    yield takeLatest(types.GET_WEBMASTER_DASHBOARD, getWebmasterDashboard);
    yield takeLatest(types.GET_CTRL_ALL_COMPLAINTS, getCtrlAllComplaints);
}
